import React from "react";
import { ImagenKarman, ListKarman, ParafhKarman , SuportHeaderKarman, TicTacKarman ,CodeKarman , TableKarman} from "./KarmanEast";

export function KarmanWest({ props }) {
  switch (props.id) {
    case 13: 
    return(
      <>
        <SuportHeaderKarman props={props} rangos={[2]} DistributeIndex={[4]} />
        <ParafhKarman props={props} rangos={[0,4]} DistributeIndex={[0]}/>
        <SuportHeaderKarman props={props} rangos={[3]} DistributeIndex={[4]} />
        <ParafhKarman props={props} rangos={[4,2]} DistributeIndex={[0]}/>
        <SuportHeaderKarman props={props} rangos={[2]} DistributeIndex={[6]} />
        <ListKarman props={props}  rangos={[0,1]}  DistributeIndex={[0]}/>
        <TicTacKarman props={props} rangos={[0,2]}  DistributeIndex={[0]} />
        <ListKarman props={props}  rangos={[1,4]}  DistributeIndex={[0]}/>
        <ImagenKarman props={props} rangos={[1,3]} DistributeIndex={[0]}/>
        <br />
        <ParafhKarman props={props} rangos={[6]} DistributeIndex={[1]}/>
        <br />
        <ImagenKarman props={props} rangos={[4,3]} DistributeIndex={[0]}/>
        <ParafhKarman props={props} rangos={[7,23]} DistributeIndex={[0]}/>
        <TableKarman props={props} rangos={[3,2]} DistributeIndex={[0]}/>
        <TicTacKarman props={props} rangos={[2]}  DistributeIndex={[1]} />
        <ParafhKarman props={props} rangos={[29,4]} DistributeIndex={[0]}/>
        <TicTacKarman props={props} rangos={[3]}  DistributeIndex={[1]} />
        <ParafhKarman props={props} rangos={[33,2]} DistributeIndex={[0]}/>
        <TicTacKarman props={props} rangos={[4]}  DistributeIndex={[1]} />
        <ParafhKarman props={props} rangos={[35,3]} DistributeIndex={[0]}/>
        <br /><br />
      </>
    );
    case 12:
      return(
        <>
          <ParafhKarman props={props} rangos={[0,3]} DistributeIndex={[0]}/>
          <CodeKarman props={props} />
          <TicTacKarman props={props} rangos={[0]}  DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[1,4]} DistributeIndex={[0]} />
          <br />
        </>
      );
    case 11:
      return(
        <>
          <ParafhKarman props={props} rangos={[0]} DistributeIndex={[1]} />
          <SuportHeaderKarman props={props} rangos={[2]} DistributeIndex={[3]} />
          <ListKarman  props={props}  rangos={[0,4]} DistributeIndex={[0]} />
          <SuportHeaderKarman props={props} rangos={[3]} DistributeIndex={[3]} />
          <ListKarman  props={props}  rangos={[4,5]} DistributeIndex={[0]} />
          <SuportHeaderKarman props={props} rangos={[4]} DistributeIndex={[3]} />
          <ListKarman  props={props}  rangos={[6,4]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[0]} DistributeIndex={[4]} />
          <ParafhKarman props={props} rangos={[1]} DistributeIndex={[1]} />
          <ParafhKarman props={props} rangos={[2]} DistributeIndex={[1]} />
          <ListKarman  props={props}  rangos={[10,5]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[3]} DistributeIndex={[1]} />
          <ParafhKarman props={props} rangos={[4]} DistributeIndex={[1]} />
          <ParafhKarman props={props} rangos={[5]} DistributeIndex={[1]} />
          <ImagenKarman props={props} rangos={[1,6,5]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[11,2]} DistributeIndex={[2]} />
          <TicTacKarman props={props} rangos={[0]} DistributeIndex={[0]} />
          <ListKarman  props={props}  rangos={[15,2]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[2,2]} DistributeIndex={[1]} />
          <ListKarman  props={props}  rangos={[17,1]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[4,14]} DistributeIndex={[2]} />
          <ImagenKarman props={props} rangos={[5,15]} DistributeIndex={[3]} />
          <ImagenKarman props={props} rangos={[6,2]} DistributeIndex={[1]} />
          <ParafhKarman props={props} rangos={[16]} DistributeIndex={[1]} />
          <ImagenKarman props={props} rangos={[8,17]} DistributeIndex={[3]} />
          <ParafhKarman props={props} rangos={[18,3]} DistributeIndex={[2]} />
          <ListKarman  props={props}  rangos={[19,5]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[21]} DistributeIndex={[1]} />
          <ListKarman  props={props}  rangos={[24,5]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[22]} DistributeIndex={[1]} />
          <TicTacKarman props={props} rangos={[1]} DistributeIndex={[0]} />
          <ListKarman  props={props}  rangos={[29,3]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[23]} DistributeIndex={[1]} />
          <ListKarman  props={props}  rangos={[32,3]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[24,4]} DistributeIndex={[2]} />
          <ListKarman  props={props}  rangos={[35,3]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[28]} DistributeIndex={[1]} />
          <ListKarman  props={props}  rangos={[38,4]} DistributeIndex={[0]} />
          <SuportHeaderKarman props={props} rangos={[5]} DistributeIndex={[4]} />
          <ParafhKarman props={props} rangos={[29,32]} DistributeIndex={[2]} />
        </>
      );
    case 10:
      return(
        <>
          <ParafhKarman props={props} rangos={[0]} DistributeIndex={[0]} />
          <ListKarman  props={props} rangos={[0,4]}  DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[1]} DistributeIndex={[0]} />
          <SuportHeaderKarman props={props} rangos={[2]} DistributeIndex={[4]} />
          <ParafhKarman props={props} rangos={[2]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[3]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[1,4]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[5]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[2,3]} DistributeIndex={[1]} />
          <ListKarman  props={props} rangos={[4,12]}  DistributeIndex={[0]} /> 
          <ImagenKarman props={props} rangos={[5]}  DistributeIndex={[2]} />
        </>
      );
    case 9:
      return (
        <>
          <ParafhKarman props={props} rangos={[]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[0]} DistributeIndex={[0]}/>
        </>
      );
    case 8:
      return(
        <>
          <ParafhKarman props={props} rangos={[0]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[0,1,2]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[3]} DistributeIndex={[1]} />
        </>
      );
    case 7:
      return(
        <>
        <ParafhKarman props={props} rangos={[0]} DistributeIndex={[0]}/>
        <ImagenKarman props={props} rangos={[0,1]} DistributeIndex={[0]}/>
        <ImagenKarman props={props} rangos={[1,2]} DistributeIndex={[1]} />
        <ImagenKarman props={props} rangos={[2,3]} DistributeIndex={[2]}/>
        <ParafhKarman props={props} rangos={[4,3]} DistributeIndex={[1]} />
        <ImagenKarman props={props} rangos={[5,7]} DistributeIndex={[3]}/>
        <ParafhKarman props={props} rangos={[8,3]} DistributeIndex={[2]} />
        <ImagenKarman props={props} rangos={[3,11,4]} DistributeIndex={[4]} />
        <ParafhKarman props={props} rangos={[16]} DistributeIndex={[3]} />
        <ImagenKarman props={props} rangos={[4,8]} DistributeIndex={[5]} />
        </>
      );
    case 6:
      return(
        <>
          <ParafhKarman props={props} rangos={[0]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[0,1,2]} DistributeIndex={[0]}  />
          <ParafhKarman props={props} rangos={[3]} DistributeIndex={[1]}  />
        </>
      );
    case 5:
      return(
        <>
          <ParafhKarman props={props} rangos={[0]} DistributeIndex={[0]} />
          <TicTacKarman props={props} rangos={[0]}  DistributeIndex={[0]} />
        </>
      );
    case 4:
      return(
        <>
          <ParafhKarman props={props} rangos={[0,2]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[1,2,2]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[0,4,1]} DistributeIndex={[1]}/>
          <ImagenKarman props={props} rangos={[2,5]} DistributeIndex={[2]} />
          <ImagenKarman props={props} rangos={[3]} DistributeIndex={[3]} />
          <ParafhKarman props={props} rangos={[6]} DistributeIndex={[1]} />
        </>
      );
    case 3: 
      return(
        <>
          <ParafhKarman props={props} rangos={[0]} DistributeIndex={[0]} />
          <ListKarman  props={props}  rangos={[]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[2]} DistributeIndex={[1]}   />
          <TicTacKarman props={props} rangos={[0]}  DistributeIndex={[0]} />
        </>
      );       
    case 2:
      return(
        <>
          <ParafhKarman props={props} rangos={[0]} DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[0,1]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[2]} DistributeIndex={[0]} />
          <TicTacKarman props={props} rangos={[0]}  DistributeIndex={[0]} />
        </>
      );  
    case 1 :
      return(
        <>
          <ParafhKarman props={props} rangos={[0,3]} DistributeIndex={[0]}  />
          <SuportHeaderKarman props={props} rangos={[0]} DistributeIndex={4}/>
          <ParafhKarman props={props} rangos={[3,4]} DistributeIndex={[0]}  />
          <ListKarman props={props} rangos={[]} DistributeIndex={[0]}  />
          <ImagenKarman props={props} rangos={[0,7]} DistributeIndex={[0]} />
          <ParafhKarman props={props} rangos={[8,2]} DistributeIndex={[0]}  />
          <ImagenKarman props={props} rangos={[1,10,8]} DistributeIndex={[1]} />
          <TicTacKarman props={props} rangos={[0]}  DistributeIndex={[0]} />
          <ImagenKarman props={props} rangos={[2,18]}  DistributeIndex={[0]}/>
          <SuportHeaderKarman props={props} rangos={[1]} DistributeIndex={[5]} />
          <SuportHeaderKarman props={props} rangos={[2]} DistributeIndex={[6]} />
          <ParafhKarman props={props} rangos={[19]} DistributeIndex={[1]}  />
        </>
      );  
    default:
      break;
  }
}
